var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { registerAutomotive } from '../registryCore';
import { ALL_CATALOG_WIDGETS } from '../catalog';
import { buildBadgeWidget, buildBarWidget, buildDialWidget, buildInfoPanel, buildLampWidget, buildNumericWidget, } from '../primitives/builders';
import { num, str } from '../helpers';
var registered = new Set();
function registerCatalogWidget(def) {
    if (registered.has(def.type))
        return;
    registered.add(def.type);
    switch (def.kind) {
        case 'dial':
            registerAutomotive(def.type, function (props, app) {
                var _a, _b;
                return buildDialWidget(app, def.type, def.type, props, {
                    max: num(props, 'max', (_a = def.max) !== null && _a !== void 0 ? _a : 100),
                    format: (_b = def.format) !== null && _b !== void 0 ? _b : 'int',
                    unit: def.unit,
                    tickCount: def.tickCount,
                    redlineFrom: def.redlineFrom,
                });
            });
            break;
        case 'bar':
            registerAutomotive(def.type, function (props, app) {
                return buildBarWidget(app, def.type, def.type, props, {
                    label: def.label,
                    unit: def.unit,
                    warnBelow: def.warnBelow,
                });
            });
            break;
        case 'numeric':
            registerAutomotive(def.type, function (props, app) {
                return buildNumericWidget(app, def.type, def.type, props, {
                    title: def.title,
                    unit: def.unit,
                    decimals: def.decimals,
                });
            });
            break;
        case 'lamp':
            registerAutomotive(def.type, function (props, app) {
                return buildLampWidget(app, def.type, def.type, props, def.symbol);
            });
            break;
        case 'badge':
            registerAutomotive(def.type, function (props, app) {
                var title = str(props, 'title', def.title);
                if (def.type === 'cruiseControl' || def.type === 'cruiseControlStatus') {
                    return buildCruiseBadge(app, def.type, props);
                }
                return buildBadgeWidget(app, def.type, def.type, props, title);
            });
            break;
        case 'panel':
            registerAutomotive(def.type, function (props, app) {
                return buildInfoPanel(app, def.type, def.type, props, def.title, def.rows);
            });
            break;
    }
}
function buildCruiseBadge(app, type, props) {
    var speed = num(props, 'speed', num(props, 'value', 0));
    return buildBadgeWidget(app, type, type, __assign(__assign({}, props), { status: speed > 0 ? "SET ".concat(Math.round(speed)) : 'OFF' }), 'Cruise');
}
export function registerCatalogWidgets() {
    var e_1, _a;
    try {
        for (var ALL_CATALOG_WIDGETS_1 = __values(ALL_CATALOG_WIDGETS), ALL_CATALOG_WIDGETS_1_1 = ALL_CATALOG_WIDGETS_1.next(); !ALL_CATALOG_WIDGETS_1_1.done; ALL_CATALOG_WIDGETS_1_1 = ALL_CATALOG_WIDGETS_1.next()) {
            var def = ALL_CATALOG_WIDGETS_1_1.value;
            registerCatalogWidget(def);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (ALL_CATALOG_WIDGETS_1_1 && !ALL_CATALOG_WIDGETS_1_1.done && (_a = ALL_CATALOG_WIDGETS_1.return)) _a.call(ALL_CATALOG_WIDGETS_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
registerCatalogWidgets();
